<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SiteBase from '../../../../sites/components/SiteBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <SiteBase />
</template>